import { render } from "./Filterable.vue?vue&type=template&id=54b01fc8"
import script from "./Filterable.vue?vue&type=script&lang=js"
export * from "./Filterable.vue?vue&type=script&lang=js"
script.render = render

export default script